import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import CompanyExecutiveTile from './company-executive-tile';

const CompanyExecutive = ({ executives }) => {
  const renderedExecutives = _.map(executives, (executive, name) => (
    <CompanyExecutiveTile {...executive} key={`item-${name}`} />
  ));

  return (
    <div>
      <div
        className={classNames([
          'executive__cont',
          classes('margin-horizontal-auto'),
          classes('padding-vertical-0'),
          classes('padding-horizontal-3'),
          classes('padding-horizontal-0--wide'),
          classes('margin-vertical-0--wide'),
        ])}
      >
        {renderedExecutives}
      </div>
    </div>
  );
};

CompanyExecutive.displayName = 'Company Executive';

CompanyExecutive.propTypes = {
  executives: PropTypes.arrayOf(PropTypes.shape(CompanyExecutive.propTypes)),
  className: PropTypes.string,
  name: PropTypes.string,
};

export default CompanyExecutive;
